import * as congNoConstant from './constants'

const initialState = {
  type: congNoConstant.CONGNO_KH_LIST_INITING,
  listRequesting: false,
  isRequesting: false,
  requesting: false,
  successful: false,
  isPopupLoading: false,
  messages: [],
  errors: [],
}

const reducer = function congNoKhachHangReducer(state = initialState, action) {
  switch (action.type) {
    case congNoConstant.CONGNO_KH_DVHC_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
      }

    case congNoConstant.CONGNO_KH_DVHC_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }

    case congNoConstant.CONGNO_KH_DVHC_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }
    case congNoConstant.CONGNO_KH_NVKD_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
      }

    case congNoConstant.CONGNO_KH_NVKD_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }

    case congNoConstant.CONGNO_KH_NVKD_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }
    case congNoConstant.CONGNO_KH_KH_LIST_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }

    case congNoConstant.CONGNO_KH_KH_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }

    case congNoConstant.CONGNO_KH_KH_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }

    case congNoConstant.CONGNO_KH_LIST_REQUESTING:
      return {
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case congNoConstant.CONGNO_KH_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case congNoConstant.CONGNO_KH_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case congNoConstant.CONGNO_KH_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case congNoConstant.CONGNO_KH_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case congNoConstant.CONGNO_KH_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case congNoConstant.CONGNOCT_KH_LIST_REQUESTING:
      return {
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case congNoConstant.CONGNOCT_KH_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case congNoConstant.CONGNOCT_KH_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case congNoConstant.CONGNO_KH_UPDATE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: true,
        isRequesting: true,
        successful: false,
        messages: [],
        errors: [],
      }

    case congNoConstant.CONGNO_KH_UPDATE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        isRequesting: false,
        successful: true,
        messages: [{
          body: "Cập nhật công nợ thành công",
          time: new Date(),
        }],
        errors: [],
      }

    case congNoConstant.CONGNO_KH_UPDATE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        isRequesting: false,
        requesting: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case congNoConstant.CONGNO_NV_BY_KH_LIST_REQUESTING:
      return {
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case congNoConstant.CONGNO_NV_BY_KH_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case congNoConstant.CONGNO_NV_BY_KH_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case congNoConstant.CONGNO_NV_BY_KH_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case congNoConstant.CONGNO_NV_BY_KH_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case congNoConstant.CONGNO_NV_BY_KH_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
      case congNoConstant.CONGNO_NV_BY_KH_UPLOAD_REQUESTING:
        return {
          ...state, // ensure that we don't erase fetched ones
          type: action.type,
          isPopupLoading: true,
          messages: [],
          errors: [],
          formData: action.payload,
          callback: action.callback,
        }
  
      case congNoConstant.CONGNO_NV_BY_KH_UPLOAD_SUCCESS:
        return {
          ...state, // ensure that we don't erase fetched ones
          type: action.type,
          isPopupLoading: false,
          successful: true,
          messages: [{
            body: action.payload.message,
            time: new Date(),
          }],
          errors: [],
        }
  
      case congNoConstant.CONGNO_NV_BY_KH_UPLOAD_ERROR:
        return {
          ...state, // ensure that we don't erase fetched ones
          type: action.type,
          isPopupLoading: false,
          successful: false,
          errors: [{
            body: action.error.toString(),
            time: new Date(),
          }],
        }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/CongNoKhachHang/reducer.js